// @ts-strict-ignore
import { Tree } from '../../services/backend/model/tree';
import { KeyMap } from '../../services/climate-engine/ccc-algorithm/key-map';
import { CccData } from '../../services/climate-engine/model/calculation-result';
import { getCccs } from '../emission-inventory/emission-inventory-helpers';

export function filterCccData(cccData: KeyMap<CccData>, treeForFilter: Tree): KeyMap<CccData> {
  cccData ??= {};
  const whiteList: string[] = getCccs(treeForFilter).map((ccc) => ccc.ccc);
  const filteredCccData: KeyMap<CccData> = {};
  Object.keys(cccData).forEach((cccId) => {
    if (whiteList.includes(cccId)) {
      filteredCccData[cccId] = cccData[cccId];
    }
  });
  return filteredCccData;
}
